(function() {
    function initializeswiperPlates() {
        const platesSections = document.querySelectorAll('.plates');

        platesSections.forEach((section, index) => {
            const $classplates = 'plates';
            const swiperContainer = section.querySelector(`.${$classplates}__carousel`);
            const swiperWrapper = section.querySelector(`.${$classplates}__ribbon`);
            const conindBlockplates = section.querySelector(`.${$classplates}__block`);
            const conindplates = section.querySelector('.plates__conind');

            // Generowanie unikalnych klas dla nawigacji
            const prevButton = section.querySelector(`.${$classplates}__controller--left`);
            const nextButton = section.querySelector(`.${$classplates}__controller--right`);

            // Dodanie unikalnych identyfikatorów dla elementów nawigacyjnych
            const swiperPlates = new Swiper(swiperContainer, {
                wrapperClass: swiperWrapper.className,
                slideClass: `${$classplates}__panel`,
                direction: 'horizontal',
                loop: false,
                speed: 600,
                navigation: {
                    prevEl: prevButton,
                    nextEl: nextButton,
                    disabledClass: `conind__controller--disabled-black`,
                },
                allowTouchMove: true,
                breakpoints: {
                    1: {
                        slidesPerView: 1.35,
                        spaceBetween: 16,
                    },
                    450: {
                        slidesPerView: 1.5,
                        spaceBetween: 16,
                    },
                    600: {
                        slidesPerView: 2.5,
                        spaceBetween: 16,
                    },
                    700: {
                        slidesPerView: 3,
                        spaceBetween: 16,
                    },
                    1000: {
                        slidesPerView: 4,
                        spaceBetween: 16,
                    },
                    1280: {
                        slidesPerView: 5,
                        spaceBetween: 16,
                    },
                },
            });

            function updateSlideCount() {
                const windowWidth = window.innerWidth;
                let slideCountplates;

                if (windowWidth <= 450) {
                    slideCountplates = swiperPlates.slides.length;
                } else if (windowWidth > 1 && windowWidth <= 600) {
                    slideCountplates = swiperPlates.slides.length;
                } else if (windowWidth > 600 && windowWidth <= 700) {
                    slideCountplates = swiperPlates.slides.length - 1;
                } else if (windowWidth > 700 && windowWidth <= 1000) {
                    slideCountplates = swiperPlates.slides.length - 2;
                } else if (windowWidth > 1000 && windowWidth <= 1280) {
                    slideCountplates = swiperPlates.slides.length - 3;
                } else if (windowWidth > 1280) {
                    slideCountplates = swiperPlates.slides.length - 4;
                }

                const blockWidthPercentageplates = 100 / slideCountplates;

                conindBlockplates.style.width = `${blockWidthPercentageplates}%`;
                updateBlockPosition();

                swiperPlates.on('slideChange', updateBlockPosition);

                function updateBlockPosition() {
                    const activeIndex = swiperPlates.realIndex;
                    conindBlockplates.style.left = `${blockWidthPercentageplates * activeIndex}%`;
                }
            }

            // Funkcja do sprawdzania widoczności przycisków nawigacji
            function toggleNavigationButtons() {
                const windowWidth = window.innerWidth;
                let slidesVisible = 1;

                if (windowWidth <= 450) {
                    slidesVisible = 1.35;
                } else if (windowWidth > 450 && windowWidth <= 600) {
                    slidesVisible = 1.5;
                } else if (windowWidth > 600 && windowWidth <= 700) {
                    slidesVisible = 2.5;
                } else if (windowWidth > 700 && windowWidth <= 1000) {
                    slidesVisible = 3;
                } else if (windowWidth > 1000 && windowWidth <= 1280) {
                    slidesVisible = 4;
                } else if (windowWidth > 1280) {
                    slidesVisible = 5;
                }

                // Jeżeli liczba widocznych slajdów jest większa lub równa liczbie wszystkich slajdów, wyłączamy przyciski nawigacji
                if (swiperPlates.slides.length <= slidesVisible) {
                    conindplates.classList.add('plates__conind--disabled');
                } else {
                    conindplates.classList.remove('plates__conind--disabled');
                }
            }

            // Inicjalizacja i eventy
            updateSlideCount();
            toggleNavigationButtons(); // Wywołanie przy ładowaniu

            window.addEventListener('resize', function() {
                updateSlideCount();
                toggleNavigationButtons(); // Wywołanie przy zmianie rozmiaru okna
            });

            // Dodanie klasy 'plates__carousel--loaded' po załadowaniu Swipera
            if (swiperContainer) {
                swiperContainer.classList.add(`${$classplates}__carousel--loaded`);
            }
        });
    }

    window.addEventListener('load', initializeswiperPlates);
})();
